import { applyBlueBuff, applyRedBuff, applyBaronBuff, processMajorObjectiveKill } from '../../domain/jungle.js';
import { populateChampionSelect } from './populateChampionSelect.js';

export class DebugPanelController {
  constructor({
    championEntity,
    garenEntity,
    dummyEntity,
    blueSpawner,
    redSpawner,
    floatingTextUI,
    shopUI,
    spawnJungleCampsCallback,
    getActiveJungleCampsCallback,
    switchChampionCallback
  }) {
    this.championEntity = championEntity;
    this.garenEntity = garenEntity;
    this.dummyEntity = dummyEntity;
    this.blueSpawner = blueSpawner;
    this.redSpawner = redSpawner;
    this.floatingTextUI = floatingTextUI;
    this.shopUI = shopUI;
    this.spawnJungleCampsCallback = spawnJungleCampsCallback;
    this.getActiveJungleCampsCallback = getActiveJungleCampsCallback;
    this.switchChampionCallback = switchChampionCallback;
  }

  init() {
    populateChampionSelect(document.getElementById('champion-select'));
    this.bindButtons();
  }

  setChampionEntity(newChampion) {
    this.championEntity = newChampion;
  }

  bindButtons() {
    const addGoldBtn = document.getElementById('add-gold-btn');
    if (addGoldBtn) {
      addGoldBtn.addEventListener('click', () => {
        this.championEntity.gold += 100;
        if (this.floatingTextUI) {
          this.floatingTextUI.showGoldText(this.championEntity.x, this.championEntity.z, 100);
        }
        if (this.shopUI) {
          this.shopUI.updateShopUI();
        }
      });
    }

    const resetCdsBtn = document.getElementById('reset-cooldowns-btn');
    if (resetCdsBtn) {
      resetCdsBtn.addEventListener('click', () => {
        this.championEntity.qCooldown = 0;
        this.championEntity.wCooldown = 0;
        this.championEntity.eCooldown = 0;
        this.championEntity.rCooldown = 0;
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '¡COOLDOWNS REINICIADOS!', 'true', false);
        }
      });
    }

    const addLevelBtn = document.getElementById('add-level-btn');
    if (addLevelBtn) {
      addLevelBtn.addEventListener('click', () => {
        this.championEntity.addExperience(280);
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, `NIVEL ${this.championEntity.level}!`, 'true', false);
        }
      });
    }

    const respawnBtn = document.getElementById('respawn-btn');
    if (respawnBtn) {
      respawnBtn.addEventListener('click', () => {
        if (this.garenEntity && this.garenEntity.respawn) {
          this.garenEntity.respawn(3, 3);
        }
      });
    }

    const spawnWaveBtn = document.getElementById('spawn-wave-btn');
    if (spawnWaveBtn) {
      spawnWaveBtn.addEventListener('click', () => {
        if (this.blueSpawner) this.blueSpawner.triggerWave();
        if (this.redSpawner) this.redSpawner.triggerWave();
      });
    }

    const spawnJungleBtn = document.getElementById('spawn-jungle-btn');
    if (spawnJungleBtn) {
      spawnJungleBtn.addEventListener('click', () => {
        if (this.spawnJungleCampsCallback) this.spawnJungleCampsCallback();
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '¡SELVA SPAWNEADA!', 'true', false);
        }
      });
    }

    const giveBlueBuffBtn = document.getElementById('give-blue-buff-btn');
    if (giveBlueBuffBtn) {
      giveBlueBuffBtn.addEventListener('click', () => {
        applyBlueBuff(this.championEntity, 150);
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '¡BUFF AZUL!', 'true', false);
        }
      });
    }

    const giveRedBuffBtn = document.getElementById('give-red-buff-btn');
    if (giveRedBuffBtn) {
      giveRedBuffBtn.addEventListener('click', () => {
        applyRedBuff(this.championEntity, 150);
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '¡BUFF ROJO!', 'true', false);
        }
      });
    }

    const giveBaronBuffBtn = document.getElementById('give-baron-buff-btn');
    if (giveBaronBuffBtn) {
      giveBaronBuffBtn.addEventListener('click', () => {
        applyBaronBuff(this.championEntity, 240);
        if (this.floatingTextUI) {
          this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '👑 EXALTED WITH BARON!', 'true', false);
        }
      });
    }

    const killDragonBtn = document.getElementById('kill-dragon-btn');
    if (killDragonBtn) {
      killDragonBtn.addEventListener('click', () => {
        const camps = this.getActiveJungleCampsCallback ? this.getActiveJungleCampsCallback() : [];
        const dragon = camps.find(c => c.state.id === 'dragon');
        if (dragon && dragon.state.isAlive) {
          processMajorObjectiveKill(dragon.state, this.championEntity, [this.championEntity, this.garenEntity], 10);
          if (this.floatingTextUI) {
            this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '🐉 DRAGÓN DERROTADO! +190g Equipo (+25g Bonus)', 'true', false);
          }
        }
      });
    }

    const killBaronBtn = document.getElementById('kill-baron-btn');
    if (killBaronBtn) {
      killBaronBtn.addEventListener('click', () => {
        const camps = this.getActiveJungleCampsCallback ? this.getActiveJungleCampsCallback() : [];
        const baron = camps.find(c => c.state.id === 'baron');
        if (baron && baron.state.isAlive) {
          processMajorObjectiveKill(baron.state, this.championEntity, [this.championEntity, this.garenEntity], 15);
          if (this.floatingTextUI) {
            this.floatingTextUI.showDamageText(this.championEntity.x, this.championEntity.z, '👾 BARON NASHOR DERROTADO! +300g Equipo & Buff', 'true', false);
          }
        }
      });
    }

    const stunGarenBtn = document.getElementById('stun-garen-btn');
    if (stunGarenBtn && this.garenEntity) {
      stunGarenBtn.addEventListener('click', () => {
        if (this.garenEntity.statusManager) this.garenEntity.statusManager.addEffect('stun', 3.0);
        if (this.garenEntity.applyStun) this.garenEntity.applyStun(3.0);
        if (this.floatingTextUI) this.floatingTextUI.showDamageText(this.garenEntity.x, this.garenEntity.z, '¡STUNNED!', 'magic', false);
      });
    }

    const slowGarenBtn = document.getElementById('slow-garen-btn');
    if (slowGarenBtn && this.garenEntity) {
      slowGarenBtn.addEventListener('click', () => {
        if (this.garenEntity.statusManager) this.garenEntity.statusManager.addEffect('slow', 4.0, 0.50);
        if (this.floatingTextUI) this.floatingTextUI.showDamageText(this.garenEntity.x, this.garenEntity.z, '¡SLOW 50%!', 'magic', false);
      });
    }

    const invisGarenBtn = document.getElementById('invis-garen-btn');
    if (invisGarenBtn && this.garenEntity) {
      invisGarenBtn.addEventListener('click', () => {
        this.garenEntity.isStealthed = !this.garenEntity.isStealthed;
        if (this.floatingTextUI) this.floatingTextUI.showDamageText(this.garenEntity.x, this.garenEntity.z, this.garenEntity.isStealthed ? '¡SIGILO!' : '¡REVELADO!', 'magic', false);
      });
    }

    const championSelect = document.getElementById('champion-select');
    if (championSelect && this.switchChampionCallback) {
      championSelect.addEventListener('change', (e) => {
        this.switchChampionCallback(e.target.value);
      });
    }
  }
}
